import { useQuery } from '@tanstack/react-query';
import { fetchReserveSummary } from './apiFetchReserveSummary';
import { GlobalReactQueryOptions } from '../../../../config';
import { browserClient } from '../../../../react-query';

const RESERVE_REPORT_SUMMARY_QUERY = 'reserveReportSummary';

function summaryQueryKey(reserveListId: string) {
    return [RESERVE_REPORT_SUMMARY_QUERY, reserveListId];
}

export const useReserveReportSummary = (reserveListId: string) => {
    return useQuery(summaryQueryKey(reserveListId), () => fetchReserveSummary(reserveListId), {
        ...GlobalReactQueryOptions
    });
};

export function invalidateReserveReportSummary(reserveReportId: string) {
    return browserClient.invalidateQueries({ queryKey: summaryQueryKey(reserveReportId) });
}
